import {RouterView} from 'vue-router'

export const Wholesale2Routes = [
  {
    path: '/w',
    name: 'Wholesale2Holder',
    component: () => import('@pages/wholesale2/index'),
    children: [
      {
        path: '',
        name: 'Wholesale2List',
        component: () => import('@pages/wholesale2-list/index'),
      },
      {
        path: ':id',
        name: 'Wholesale2DetailHolder',
        component: RouterView,
        children: [
          {
            path: '',
            name: 'Wholesale2Detail',
            component:  () => import('@pages/wholesale2-detail/index'),
          },
          {
            path: 'photo',
            name: 'Wholesale2Photo',
            component:  () => import('@pages/wholesale2-photo/index'),
          },
        ],
      },
    ],
  },
]
